import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService } from '../services/api';

const AnalyticsTracker: React.FC = () => {
  const location = useLocation();
  const prevPathRef = useRef<string | null>(null);

  const getPageType = (path: string) => {
    if (path === '/') return 'home';
    if (path.startsWith('/register')) return 'signup';
    if (path.startsWith('/login') || path.startsWith('/forgot-password') || path.startsWith('/reset-password')) {
      return 'auth';
    }
    if (path.startsWith('/student-pathway') || path.startsWith('/my-application')) return 'application';
    if (path.startsWith('/admin')) return 'admin';
    return 'other';
  };

  useEffect(() => {
    const pagePath = location.pathname + location.search + location.hash;
    const referrer =
      prevPathRef.current
        ? `${window.location.origin}${prevPathRef.current}`
        : document.referrer || undefined;
    const params = new URLSearchParams(location.search);
    const pageType = getPageType(location.pathname);
    if (pageType === 'admin') {
      prevPathRef.current = pagePath;
      return;
    }
    analyticsService.trackEvent({
      event_name: 'page_view',
      page_path: pagePath,
      page_title: document.title || undefined,
      page_type: pageType,
      referrer,
      utm_source: params.get('utm_source') || undefined,
      utm_medium: params.get('utm_medium') || undefined,
      utm_campaign: params.get('utm_campaign') || undefined,
      utm_term: params.get('utm_term') || undefined,
      utm_content: params.get('utm_content') || undefined,
    }).catch(() => {
      // Swallow analytics errors to avoid impacting navigation.
    });
    prevPathRef.current = pagePath;
  }, [location]);

  return null;
};

export default AnalyticsTracker;
